import { z } from 'zod';
/**
 * Рамочный договор транспортной экспедиции (договор ТЭО). Заводит менеджер для
 * клиента; поручения выдаются на его основании (формат ФНС: ДогТрЭксп).
 */
export const expeditorAgreementCreateSchema = z.object({
    number: z.string().min(1).max(100),
    /** ISO-дата заключения. */
    signedDate: z.string(),
    /** ISO-дата окончания срока (опц.; пусто = бессрочный). */
    validUntil: z.string().optional(),
    subject: z.string().max(2000).optional(),
});
export const expeditorAgreementPatchSchema = expeditorAgreementCreateSchema.partial();
export const expeditorAgreementSchema = z.object({
    id: z.string(),
    clientId: z.string(),
    number: z.string(),
    signedDate: z.string(),
    validUntil: z.string().nullable(),
    subject: z.string().nullable(),
    archivedAt: z.string().nullable(),
    /** Действует ли сейчас: не в архиве и срок не истёк. */
    isActive: z.boolean(),
    createdAt: z.string(),
});
//# sourceMappingURL=agreements.js.map